import { Component, OnInit, inject } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { ApiService } from  'src/app/services/api';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { EventDetail,SystemInfo,EventMonitoring } from '..//models/trace.model';  // Import the interfaces
import { MatSelectModule } from '@angular/material/select';
import {MatTooltipModule} from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { Location } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
    selector: 'search-table',
    imports: [
    MatTableModule,
    MatPaginatorModule,
    MatInputModule,
    MatFormFieldModule,
    MatCardModule,
    MatButtonModule,
    FormsModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatTooltipModule,  
    MatIconModule,
    MatCheckboxModule
],
    templateUrl: './event.component.html',
    styleUrls: ['./event.component.css']
})

export class EventComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  event : EventDetail|null = null;
  loading = false;
  noDataFound = false;
  error:any | null = null;
  sourceSystems: SystemInfo[] = [];
  targetSystems: SystemInfo[] = [];
  id:string |undefined = '0';
  name: string | null = null;
  friendlyName: string | null = null;
  remark: string | null = null;
  upsertEvent = false;
  selectedProducers: number[] = [];
  selectedConsumers: number[] = [];

  constructor(private location: Location,private apiService: ApiService) {}

  ngOnInit(): void {

    this.loadSourceSystem();
    this.loadTargetSystem();


  if(!this.location.path().includes('/UpsertEvent/'))
    {
      this.route.queryParamMap.subscribe(params => {
      this.name = params.get('EventName');
    });
    }
    else
    {
      this.id = this.router.url.split('/').pop();     
    }
    this.getTraces();
    this.loadEvent();
  }


  getTraces() {
    this.loading = true;
    this.noDataFound = false;
    if(this.location.path().includes('/UpsertEvent/'))
    {
      this.apiService.getDataById(this.id!).subscribe({
        next: (data) => {
          console.log(data); // Assign the data to dataSource
          if(data == null) {
            this.noDataFound = true;
          } 
          this.loading = false;
        },
        error: (message) => {
          console.error(message);
          this.loading = false;
          // General error handling
          this.error = {
            message: 'Failed to fetch logs from the server.',
            details: message || 'Unknown error occurred.'       
          };
        }
      })
    }
  }

  loadEvent():void{
    this.loading = true;
    this.apiService.getAllEventsWithSystems().subscribe({
        next: (data) => {
          console.log(data); // Assign the data to dataSource
          if(data == null) 
          {
             this.noDataFound = true;
          } 
          else 
          {
            this.event = null;
             for (const eventMonitoring  of data) 
             {
                if(eventMonitoring.Id === Number(this.id))
                {
                    this.event= Object.assign(new EventDetail(), 
                    {
                      Name: eventMonitoring.Name,
                      FriendlyName: eventMonitoring.FriendlyName,
                      Remark: eventMonitoring.Remark,
                      Id: eventMonitoring.Id,
                      Producers: eventMonitoring.Producers,
                      Consumers: eventMonitoring.Consumers
                    });
                  this.name = this.event.Name;
                  this.friendlyName = this.event.FriendlyName;
                  this.remark = this.event.Remark;
                  this.selectedConsumers = this.event.Consumers.map(s => s.Id);
                  this.selectedProducers = this.event.Producers.map(s => s.Id); 
                }
             }            
          }
          this.loading = false; },
        error: (message) => {
          console.error(message);
          this.loading = false;
          // General error handling
          this.error = {
            message: 'Failed to fetch logs from the server.',
            details: message || 'Unknown error occurred.'
          };
        }
      });
  }
  
  loadSourceSystem():void{
    this.apiService.getSourceSystem().subscribe({
        next: (data) => {
          console.log(data); // Assign the data to dataSource
          if(data == null) 
          {
             this.noDataFound = true;
          }
          else 
          {
            this.sourceSystems = [];
             for (const sourceSystem  of data) 
             {
               this.sourceSystems.push(sourceSystem);
             }
          }
          this.loading = false; },
        error: (message) => {
          console.error(message);
          this.loading = false;
          // General error handling
          this.error = {
            message: 'Failed to fetch logs from the server.',
            details: message || 'Unknown error occurred.'       
          };
        }
      });
  }

  loadTargetSystem():void{
    this.apiService.getTargetSystem().subscribe({
        next: (data) => {
          console.log(data); // Assign the data to dataSource
          if(data == null) 
          {
             this.noDataFound = true;
          }
          else 
          {
            this.targetSystems = [];
             for (const targetSystem  of data) 
             {
               this.targetSystems.push(targetSystem);
             }            
          }
          this.loading = false; },
        error: (message) => {
          console.error(message);
          this.loading = false;
          // General error handling
          this.error = {
            message: 'Failed to fetch logs from the server.',
            details: message || 'Unknown error occurred.'       
          };
        }
      });
  }

  getProducerSelected(ids: number[]): SystemInfo[] {
    return this.sourceSystems.filter(system => ids.includes(system.Id));
  }

  getConsumerSelected(ids: number[]): SystemInfo[] {
    return this.targetSystems.filter(target => ids.includes(target.Id));
  }

  applySave(): void 
  {
    if(this.name!==null || this.friendlyName!==null)
      {
        const requestBody = {
              id: this.id,
              name: this.name,
              friendlyName: this.friendlyName,
              remark : this.remark,
              producers: this.getProducerSelected(this.selectedProducers),
              consumers: this.getConsumerSelected(this.selectedConsumers)
            };

            // Create an observer object
            const observer = {
              next: (response: EventMonitoring) => {
                console.log('POST request was successful', response);
                 this.id = response.Id?.toString();
                this.upsertEvent = false;
                this.router.navigate(['/private/Tracking/Events/Producers-Consumers']);
              },
              error: (error: EventMonitoring) => {
                console.error('POST request failed', error);
                this.upsertEvent = false;                
              },
              complete: () => {
                console.log('POST request complete');
                this.upsertEvent = false;  
                this.router.navigate(['/private/Tracking/Events/Producers-Consumers']);              
              },
            };
          console.log(requestBody);
          this.apiService.upsertEvent(requestBody).subscribe(observer);
         
      }    
  }

  clearFilters(): void {
    this.selectedConsumers = [];
    this.selectedProducers = [];
    this.name = null;
    this.friendlyName = null;
    this.remark = null;
  }
}